import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import TopBar from '../components/layout/TopBar.svelte';
import Timer from '../components/session/Timer.svelte';
import BreastPicker from '../components/session/BreastPicker.svelte';
import Button from '../components/shared/Button.svelte';
import { getActiveTimer, startTimer, stopTimer, switchSide } from '../lib/stores/session.svelte.ts';
import { saveSession, getSuggestedSide } from '../lib/services/session';
import { getActiveChild } from '../lib/stores/children.svelte.ts';
import { navigate } from '../lib/router.svelte.ts';
import { showToast } from '../components/shared/Toast.svelte';

var root_3 = $.from_html(`<button class="note-toggle svelte-uygfr9158ac">+ Add note</button>`);
var root_4 = $.from_html(`<textarea class="note-input svelte-uygfr9158ac" placeholder="Optional note..." rows="2"></textarea>`);
var root_1 = $.from_html(`<div class="active-session svelte-uygfr9158ac"><div class="timer-section svelte-uygfr9158ac"><div class="side-indicator svelte-uygfr9158ac"> </div> <!></div> <div class="actions svelte-uygfr9158ac"><!> <!> <!></div></div>`);
var root_6 = $.from_html(`<div class="conflict svelte-uygfr9158ac"><p class="conflict-message svelte-uygfr9158ac"> </p> <!></div>`);
var root_8 = $.from_html(`<div class="start-label svelte-uygfr9158ac"><h3 class="start-title svelte-uygfr9158ac">Which side?</h3> <p class="start-hint svelte-uygfr9158ac">Tap to start the timer</p></div> <div class="start-picker svelte-uygfr9158ac"><!></div>`, 1);
var root = $.from_html(`<!> <div class="session-page svelte-uygfr9158ac"><!></div>`, 1);

function NursingSession($$anchor, $$props) {
	$.push($$props, true);

	const timer = $.derived(getActiveTimer);
	const activeChild = $.derived(getActiveChild);
	const suggested = $.derived(() => $.get(activeChild) ? getSuggestedSide($.get(activeChild).id) : 'left');
	let note = $.state('');
	let showNote = $.state(false);

	async function handleSelectSide(side) {
		if (!$.get(activeChild)) return;

		await startTimer($.get(activeChild).id, 'nursing', side);
	}

	async function handleEnd() {
		const stopped = await stopTimer();

		if (!stopped) return;

		try {
			const now = Date.now();

			await saveSession(stopped.childId, {
				type: 'nursing',
				startTime: stopped.startTime,
				endTime: now,
				durationMs: now - stopped.startTime,
				side: stopped.side,
				switchTimes: stopped.switchTimes,
				note: $.get(note) || undefined
			});

			navigate('/');
		} catch(e) {
			showToast('Failed to save session. Please try again.', 'error');
		}
	}

	function handleSwitch() {
		switchSide();
	}

	var fragment = root();
	var node = $.first_child(fragment);

	TopBar(node, { title: 'Nursing', showBack: true, backPath: '/log' });

	var div = $.sibling(node, 2);
	var node_1 = $.child(div);

	{
		var consequent_1 = ($$anchor) => {
			var div_1 = root_1();
			var div_2 = $.child(div_1);
			var div_3 = $.child(div_2);
			var text = $.child(div_3, true);

			$.reset(div_3);

			var node_2 = $.sibling(div_3, 2);

			Timer(node_2, {
				get startTime() {
					return $.get(timer).startTime;
				}
			});

			$.reset(div_2);

			var div_4 = $.sibling(div_2, 2);
			var node_3 = $.child(div_4);

			Button(node_3, {
				variant: 'secondary',
				fullWidth: true,
				onclick: handleSwitch,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_1 = $.text('Switch Side');

					$.append($$anchor, text_1);
				},
				$$slots: { default: true }
			});

			var node_4 = $.sibling(node_3, 2);

			{
				var consequent = ($$anchor) => {
					var button = root_3();

					$.delegated('click', button, () => $.set(showNote, true));
					$.append($$anchor, button);
				};

				var alternate = ($$anchor) => {
					var textarea = root_4();

					$.remove_textarea_child(textarea);
					$.bind_value(textarea, () => $.get(note), ($$value) => $.set(note, $$value));
					$.append($$anchor, textarea);
				};

				$.if(node_4, ($$render) => {
					if (!$.get(showNote)) $$render(consequent); else $$render(alternate, -1);
				});
			}

			var node_5 = $.sibling(node_4, 2);

			Button(node_5, {
				variant: 'primary',
				size: 'lg',
				fullWidth: true,
				onclick: handleEnd,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_2 = $.text('End Session');

					$.append($$anchor, text_2);
				},
				$$slots: { default: true }
			});

			$.reset(div_4);
			$.reset(div_1);
			$.template_effect(() => $.set_text(text, $.get(timer).side));
			$.append($$anchor, div_1);
		};

		var consequent_2 = ($$anchor) => {
			var div_5 = root_6();
			var p = $.child(div_5);
			var text_3 = $.child(p);

			$.reset(p);

			var node_6 = $.sibling(p, 2);

			Button(node_6, {
				variant: 'primary',
				size: 'lg',
				fullWidth: true,
				onclick: () => navigate(`/session/${$.get(timer).sessionType}`),
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_4 = $.text('Go to active session');

					$.append($$anchor, text_4);
				},
				$$slots: { default: true }
			});

			$.reset(div_5);
			$.template_effect(() => $.set_text(text_3, `A ${$.get(timer).sessionType ?? ''} session is already active.`));
			$.append($$anchor, div_5);
		};

		var alternate_1 = ($$anchor) => {
			var fragment_1 = root_8();
			var div_6 = $.sibling($.first_child(fragment_1), 2);
			var node_7 = $.child(div_6);

			BreastPicker(node_7, {
				selected: null,
				get suggested() {
					return $.get(suggested);
				},
				onselect: handleSelectSide
			});

			$.reset(div_6);
			$.append($$anchor, fragment_1);
		};

		$.if(node_1, ($$render) => {
			if ($.get(timer) && $.get(timer).sessionType === 'nursing') $$render(consequent_1); else if ($.get(timer) && $.get(timer).sessionType !== 'nursing') $$render(consequent_2, 1); else $$render(alternate_1, -1);
		});
	}

	$.reset(div);
	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	NursingSession = $.hmr(NursingSession);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-uygfr9158ac');
		NursingSession[$.HMR].update(module.default);
	});
}

export default NursingSession;

$.delegate(['click']);
import "bun-svelte:NursingSession.svelte-1qob2wiimiqnb-style.css";